import React from 'react'
import ReactDOM from 'react-dom'

import AnimatedNavbar from './react-stripe-menu/AnimatedNavbar'

const mount = (
    <div>
        <AnimatedNavbar duration={300} />
    </div>
)

const navTarget = document.querySelector('#nav-mount');
ReactDOM.render(mount, navTarget);